import { Component, Input } from "@angular/core";

@Component({
  selector: "app-loader-list",
  templateUrl: "loader-list.html",
})
export class LoaderListComponent {

  @Input() public message = "Loading...";
}



// WEBPACK FOOTER //
// ./src/components/loader-list/loader-list.ts